import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormArray, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { ProviderItem } from "@core/models/providers";
import { CompanyService, UserService } from "@core/services";
import { NgxToastrService } from "@core/services/ngx.toastr.service";
import { ProvidersService, ProviderType } from "@core/services/providers.service";
import { TravelUtilsService } from "@core/services/travel-utils.service";
import { UtilsService } from "@core/services/utils.service";
import { Company, User } from "@models";
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { UserCardModalComponent } from "@shared/component/user-card-modal/user-card-modal.component";
import { AppState } from "app/app.reducer";
import cities from "assets/utils/cities.json";
import hotels from "assets/utils/hotels.json";
import * as moment from "moment";
import { Subscription, take } from "rxjs";
import Swal from "sweetalert2"

interface EditableTraveler {
  type: 'internal' | 'external';
  uuid?: string;
  name: string;
  lastname: string;
}

interface RoomTraveler {
  type?: 'internal' | 'external';
  uuid?: string;
  name: string;
  lastname: string;
}

interface BookingPaymentSelection {
  payNow: boolean;
  card?: {
    name: string;
    token: string;
  };
}

@Component({
  selector: "app-create-custom-hotel",
  templateUrl: "./create-custom-hotel.component.html",
  styleUrls: ["./create-custom-hotel.component.scss"],
})
export class CreateCustomHotelComponent implements OnInit {
  @Input() isAdmin;
  @Input() loading;
  @Input() companyUuid: string;
  @Input() userId: string;
  @Output() sendInfo = new EventEmitter<any>();
  @Input() data;
  editing = false;
  isModal = true;
  hotelsList = [];
  citiesList = [];
  city = "";
  form: UntypedFormGroup;
  prefOptions = [];
  users: User[] = [];
  user: User;
  file: File;
  date = new Date();
  minDateNgStruct = {
    year: this.date.getFullYear() - 1,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  maxDateNgStruct = {
    year: this.date.getFullYear() + 20,
    month: this.date.getMonth() + 1,
    day: this.date.getDate(),
  };
  bodyTravel: any = {};
  subscriptions: Subscription[] = [];
  request: any;
  isInvalid: boolean = false
  userType;
  companyUsers: { name: string; lastname: string; uuid: string }[] = [];
  company: Company;
  @ViewChild("departure") departure: ElementRef;

  @Input() blobUrl;
  @Input() fileBack;
  files: File[] = [];
  filesToRemove: any[] = [];
  existingFiles: any[] = [];
  travelersPerRoom: FormArray;
  filteredUsers: { name: string; lastname: string; uuid: string }[] = [];
  @Input() defaultUser: any;
  bookType: any;
  selectedTravelers: EditableTraveler[] = [];
  externalTravelers: EditableTraveler[] = [];
  hotelProviderOptions: ProviderItem[] = [];
  loadingHotelProviders = false;
  private travelerSyncInitialized = false;
  maxSelection = Infinity;
  backendValidationErrors: Record<string, string> = {};
  externalGuestModeByRoom: { [roomIndex: number]: boolean } = {};
  externalGuestNameByRoom: { [roomIndex: number]: string } = {};
  externalGuestLastnameByRoom: { [roomIndex: number]: string } = {};

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private ngbDateParser: NgbDateParserFormatter,
    private travelUtilsService: TravelUtilsService,
    private utilsService: UtilsService,
    private modalService: NgbModal,
    private ngxToastrService: NgxToastrService,
    private userService: UserService,
    private store: Store<AppState>,
    private companyService: CompanyService,
    private providersService: ProvidersService
  ) { }

  ngOnInit(): void {
    if (this.fileBack) {
      this.existingFiles = Array.isArray(this.fileBack) ? this.fileBack : [this.fileBack];
    }
    if (Array.isArray(this.files[0])) {
      this.files = this.files.reduce((acc, val) => acc.concat(val), []);
    }

    this.bookType = this.data?.type;
    this.data && this.data !== null
      ? (this.editing = true)
      : (this.editing = false);
    if (this.userId) {
      this.userService
        .getUser(this.userId)
        .pipe(take(1))
        .subscribe((user: User) => {
          this.user = user;
          if (!this.data?.hotel && this.userType === "EMPLOYEE" && this.bookType !== 'airbnb') {
            this.defaultUser = {
              type: 'internal',
              name: this.user.name,
              lastname: this.user.lastname,
              uuid: this.user.uuid
            };

            if (!this.request) {
              this.form.get("defaultTraveler")?.setValue([{ 
                type: 'internal',
                uuid: this.defaultUser.uuid, 
                name: this.defaultUser.name, 
                lastname: this.defaultUser.lastname 
              }]);

              this.updateTravelersPerRoom(this.form.get('rooms')?.value || 1);
            }
          }

          if (this.user?.companyUuid) {
            this.companyService.getCompany(this.user.companyUuid).subscribe(
              (company: Company) => {
                this.company = company;
              },
              (error) => {}
            );
          }
        });
    }
    this.store
      .select("auth")
      .pipe(take(1))
      .subscribe((res) => {
        if (res.isAuthenticated) {
          this.userType = res.user.type;
        }
      });
    this.form = this.formBuilder.group({
      file: [
        this.editing ? this.data.file : '',
        this.fileBack && this.blobUrl ? [] : [],
      ],
      hotel: [
        { value: this.editing
          ? this.data.hotel
            ? this.data.hotel.name
            : this.data.hotelName
          : this.request
            ? this.request.hotelName
            : '', disabled: (this.editing && this.data.codePetition) ||this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      locator: [
        this.editing
          ? (this.data.locator ? this.data.locator : (this.data.apiReference ? this.data.apiReference : this.data.bookedApiReference ))
          : this.request
            ? this.request.locator
            : "",
      ],
      customCode: [
        this.editing && this.data?.customCode && this.data.customCode !== "null"
          ? this.data.customCode
          : this.request?.customCode && this.request.customCode !== "null"
            ? this.request.customCode
            : "",
      ],
      costCenter: [
        this.editing && this.data?.costCenter && this.data.costCenter !== "null"
          ? this.data.costCenter
          : this.request?.costCenter && this.request.costCenter !== "null"
            ? this.request.costCenter
            : "",
      ],
      city: [
        { value: this.editing
          ? this.data.hotel
            ? this.data.hotel.destinationName
            : this.data.destinationName
          : this.request
            ? this.request.city
            : '', disabled: (this.editing && this.data.codePetition) || this.userType != "EMPLOYEE" },
        [Validators.required],
      ],
      checkIn: [
        this.editing
          ? this.ngbDateParser.parse(
            moment(this.data.checkIn).toString()
          )
          : '',
        [Validators.required],
      ],
      checkOut: [
        this.editing
          ? this.ngbDateParser.parse(
            moment(this.data.checkOut).toString()
          )
          : '',
        [Validators.required],
      ],
      supplierInvoice: [
        {
        value: this.editing ? (this.data?.supplierInvoice ?? '') : (this.request?.supplierInvoice ?? ''),
        disabled: this.userType !== 'EMPLOYEE' 
        }
      ],
      bookType: [
        {
          value: this.editing ? (this.data?.bookType ?? '') : '',
          disabled: this.userType !== 'EMPLOYEE'
        }
      ],
      comments: [{ value: this.editing ? this.data.comments : "", disabled: this.userType != "EMPLOYEE" }],
      userUuid: this.userId,
      provider: [{ 
        value: this.editing ? (this.data?.provider || '') : '', 
        disabled: this.userType !== 'EMPLOYEE' 
      }],
      invoiced: [{
        value: this.editing ? (this.data?.invoiced || 'none') : 'none',
        disabled: this.userType !== 'EMPLOYEE'
      }],
    });

    if (this.editing) {
      this.form.addControl('price', new FormControl(
        {
          value: this.data.price.toFixed(2),
          disabled: this.data?.payment || this.data?.refund || this.userType != "EMPLOYEE"
        },
        [Validators.required, Validators.pattern(/^\d+([.,]\d{1,2})?$/)]
      ));
      this.form.addControl('wholesalePrice', new FormControl(
        {
          value: typeof this.data?.wholesalePrice === 'number'
            ? this.data.wholesalePrice.toFixed(2)
            : (this.data?.wholesalePrice || ''),
          disabled: this.userType != "EMPLOYEE"
        },
        [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]
      ));

      if(!this.data.hotel) {
        this.form.addControl('roomType', new FormControl(
          {
            value: this.data.roomType || '',
            disabled: this.userType != "EMPLOYEE"
          }
        ));

        this.form.addControl('boardType', new FormControl(
          {
            value: this.data.boardType || '',
            disabled: this.userType != "EMPLOYEE"
          }
        ));
      }

      this.form.addControl('provider', new FormControl({
        value: this.data.provider || '',
        disabled: this.userType != "EMPLOYEE"
      }));

      this.form.addControl('marketingFee', new FormControl({
        value: typeof this.data?.marketingFee === 'number'
          ? this.data.marketingFee.toFixed(2)
          : (this.data?.marketingFee || ''),
        disabled: this.userType !== 'EMPLOYEE'
      }, [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]));

      this.form.addControl('freeTaxes', new FormControl(
        {
          value: this.editing && this.data !== null && this.data.freeTaxes
            ? this.data.freeTaxes
            : false,
          disabled: this.userType !== "EMPLOYEE"
        },
        this.editing && this.data?.codePetition ? null : Validators.required
      ));
    }

    if (!this.data?.hotel && this.userType === "EMPLOYEE" && this.bookType !== 'airbnb') {
      const roomsValue = Number(this.request?.rooms) || 1;

      this.form.addControl('rooms', new FormControl(roomsValue, [
        Validators.required,
        Validators.min(1)
      ]));

      this.form.addControl('travelersPerRoom', this.formBuilder.array([]));
      this.form.addControl('defaultTraveler', this.formBuilder.control([]));

      this.travelersPerRoom = this.form.get("travelersPerRoom") as FormArray;

      if (!this.editing) {
        this.form.addControl('roomsInfo', this.formBuilder.array([]));
        this.initRoomsInfo(roomsValue);

        this.updateTravelersPerRoom(roomsValue);

        if (this.request) {
          this.loadRequestTravelersPerRoom();
        }

        this.form.get("rooms")?.valueChanges.subscribe(value => {
          this.updateTravelersPerRoom(value);
          this.initRoomsInfo(value);

          if (this.request) {
            this.loadRequestTravelersPerRoom();
          }
        });
      } else {
        this.getCompanyUsers(() => {
          const travelers = this.buildInitialCustomRoomTravelers() as EditableTraveler[];

          this.selectedTravelers = [...travelers];

          this.externalTravelers = travelers.filter(
            (traveler) => traveler.type === 'external'
          );

          this.form.get("defaultTraveler")?.setValue(travelers);

          this.form.get("traveler")?.setValue(
            travelers
              .map((traveler) => traveler.uuid)
              .filter(Boolean),
            { emitEvent: false }
          );

          this.form.get("defaultTraveler")?.markAsPristine();
          this.form.get("defaultTraveler")?.updateValueAndValidity();

          this.form.get("rooms")?.valueChanges.subscribe(value => {
            this.updateTravelersPerRoom(value);
          });
        });
      }

    }

    if (this.editing) {
      const initialIds = Array.isArray(this.data?.userUuid)
        ? this.data.userUuid
        : (this.data?.userUuid ? [this.data.userUuid] : []);

      const guestsCount = Array.isArray(this.data?.guests)
        ? this.data.guests.length
        : 0;

      this.maxSelection = guestsCount || initialIds.length || 1;

      this.form.addControl('traveler', new FormControl({
        value: [],
        disabled: !(this.userType?.toLowerCase() === 'employee' || this.userType?.toLowerCase() === 'company')
      }));
    }

    if (this.data?.hotel) {
      this.form.addControl('address', new FormControl({ value: this.data ? this.data?.hotel?.address : '', disabled: this.userType != "EMPLOYEE" },
        [Validators.required]
      ));
    }
  
    if (this.form.value.checkIn) {
      this.form.patchValue({ checkIn: { day: this.form.value.checkIn.day, month: this.form.value.checkIn.month + 1, year: this.form.value.checkIn.year  } })
    }
    if (this.form.value.checkOut) {
      this.form.patchValue({ checkOut: { day: this.form.value.checkOut.day, month: this.form.value.checkOut.month + 1, year: this.form.value.checkOut.year } })
    }
    if (this.request) {
      this.request.initDate = moment(this.request.initDate).format(
        "DD/MM/YYYY"
      );
      const valueInit = {
        year: this.request.initDate.toString().split("/")[2] * 1,
        month: this.request.initDate.split("/")[1] * 1,
        day: this.request.initDate.split("/")[0] * 1,
      };
      this.form.patchValue({ checkIn: valueInit });
      this.request.endDate = moment(this.request.endDate).format("DD/MM/YYYY");
      const valueEnd = {
        year: this.request.endDate.toString().split("/")[2] * 1,
        month: this.request.endDate.split("/")[1] * 1,
        day: this.request.endDate.split("/")[0] * 1,
      };
      this.form.patchValue({ checkOut: valueEnd });
    }
  
    if (
      this.editing &&
      (
        this.data?.hotel ||
        this.bookType === 'airbnb'
      )
    ) {
      this.getCompanyUsersAndUpdate();
    }

    if(!this.data?.hotel && !this.editing && this.userType === "EMPLOYEE"){
      this.getCompanyUsers();
    }

    this.loadHotelProviders();
  }

  // Buscador de ciudades
  getCities(value: string) {
    this.citiesList = [];
    if (value !== "" && value.length > 2) {
      cities.Table1.forEach((v) => {
        if (
          v["name"]?.toLowerCase().includes(value?.toLowerCase()) &&
          !this.citiesList.includes(v["name"])
        ) {
          this.citiesList.push(v["name"]);
        }
      });
    } else {
      this.citiesList = [];
    }
  }

  get f() {
    return this.form.controls;
  }

  getHotels(value: string) {
    if (value !== "" && this.city !== "") {
      hotels.hotels.forEach((h) => {
        {
          if (
            h["city"]?.toLowerCase().includes(this.city?.toLowerCase()) &&
            !this.hotelsList.includes(h.name)
          ) {
            this.hotelsList.push(h.name);
          }
        }
      });
    } else {
      this.hotelsList = [];
    }
  }

  cleanCitiesList(option) {
    this.city = option;
    this.citiesList = [];
  }

  cleanHotelsList() {
    this.hotelsList = [];
  }

  async onSubmit(): Promise<void> {
    if (this.editing) {
      this.processBookingForm();
      return;
    }

    if (!this.company || !this.user) {
      this.loading = false;
      return;
    }

    const paymentSelection = await this.showPaymentCardSelector();

    if (paymentSelection === null) {
      this.loading = false;
      return;
    }

    this.processBookingForm(paymentSelection.card);
  }
  
  processBookingForm(selectedCard?: any) {
    this.isInvalid = false;
    this.loading = true;
    const travel = this.travelUtilsService.getTravelLocalStorage();
    const body = this.form.getRawValue();
    if (this.data?.hotel || this.bookType === 'airbnb') {
      const internalTravelers = this.selectedTravelers
        .filter((traveler) => traveler.type === 'internal' && !!traveler.uuid)
        .map((traveler) => ({
          uuid: traveler.uuid,
          name: traveler.name,
          lastname: traveler.lastname
        }));

      body.traveler = internalTravelers;

      if (this.data?.hotel) {
        const orderedSelectedTravelers = [
          ...this.selectedTravelers.filter((traveler) => traveler.type === 'internal'),
          ...this.selectedTravelers.filter((traveler) => traveler.type === 'external'),
        ];

        body.guests = orderedSelectedTravelers.map((traveler) => ({
          name: traveler.name,
          surname: traveler.lastname
        }));
      }

      if (this.bookType === 'airbnb') {
        delete body.guests;
      }
    }
    body["checkIn"] = moment(this.ngbDateParser.format(body["checkIn"]), "DD/MM/YYYY").format("YYYY-MM-DD");
    body["checkOut"] = moment(this.ngbDateParser.format(body["checkOut"]), "DD/MM/YYYY").format("YYYY-MM-DD");
    if (this.editing && body["price"]) {
      body["price"] = parseFloat(body["price"].toString().replace(",", ".")).toFixed(2);
    }
    if (this.editing) {
      if (
        body["wholesalePrice"] !== undefined &&
        body["wholesalePrice"] !== null &&
        body["wholesalePrice"] !== ''
      ) {
        body["wholesalePrice"] = parseFloat(
          body["wholesalePrice"].toString().replace(",", ".")
        ).toFixed(2);
      } else {
        delete body["wholesalePrice"];
      }
    }
    if (this.editing) {
      if (body["marketingFee"] !== undefined && body["marketingFee"] !== null && body["marketingFee"] !== '') {
        body["marketingFee"] = Number(
          body["marketingFee"].toString().replace(",", ".")
        );
      } else {
        delete body["marketingFee"];
      }
    }
    if (this.editing && this.data.codePetition) {
      delete body['freeTaxes'];
    }

    if (this.request || this.user) {
      body['holder'] = this.request ? this.request.holder : this.user ? { name: this.user.name, surname: this.user.lastname } : null;
    }

    if (this.userId) {
      body["userUuid"] = this.userId;
    }
    if (travel && travel.title) {
      body["travelName"] = travel.title;
    }
    if (selectedCard) {
      body["paymentCard"] = {
        name: selectedCard.name,
        token: selectedCard.token,
      };
    }
    body["file"] = this.files.length > 0 ? this.files : [];
    body.file = body.file.flat();
    body["filesToRemove"] = this.filesToRemove;
    if (!this.data?.hotel && this.userType === "EMPLOYEE" && this.bookType !== 'airbnb') {
      const allTravelersPerRoom = [
        this.form.get("defaultTraveler")?.value || [],
        ...this.getTravelersPerRoom?.value
      ];

      body["rooms"] = allTravelersPerRoom.length;

      body["travelersPerRoom"] = allTravelersPerRoom.map((roomTravelers: any[]) => {
        return (roomTravelers || []).map((traveler) => {
          if (traveler?.type === 'external') {
            return {
              type: 'external',
              uuid: traveler.uuid,
              name: traveler.name || '',
              lastname: traveler.lastname || '',
            };
          }

          return {
            type: 'internal',
            uuid: traveler.uuid,
            name: traveler.name || '',
            lastname: traveler.lastname || '',
          };
        });
      });
    }
    const roomsInfoControl = this.form.get('roomsInfo');
    if (roomsInfoControl && !this.editing) {
      body["roomsInfo"] = roomsInfoControl.value.map(room => {
        const { provider, marketingFee, wholesalePrice, ...rest } = room;
        const parsedWholesalePrice =
          wholesalePrice !== '' && wholesalePrice != null
            ? parseFloat(wholesalePrice.toString().replace(",", ".")).toFixed(2)
            : null;
        const parsedMarketingFee =
          marketingFee !== '' && marketingFee !== null && marketingFee !== undefined
            ? Number(marketingFee.toString().replace(",", "."))
            : null;

        return {
          ...rest,
          price: parseFloat(room.price.toString().replace(",", ".")).toFixed(2),
          providerUuid: provider || null,
          ...(parsedWholesalePrice !== null ? { wholesalePrice: parsedWholesalePrice } : {}),
          ...(parsedMarketingFee !== null && !Number.isNaN(parsedMarketingFee)
            ? { marketingFee: parsedMarketingFee }
            : {})
        };
      });
    }

    if(this.bookType === 'airbnb' || this.data?.hotel){
      delete body['travelersPerRoom'];
      delete body['defaultTraveler'];
    }
    if (this.bookType === 'airbnb') {
      delete body['guests'];
    }
    if (!body.bookType) {
      delete body.bookType;
    }
    if (body.provider) {
      body.providerUuid = body.provider;
    }

    if (
      !this.data?.hotel &&
      this.bookType !== 'airbnb' &&
      (!body.travelersPerRoom || !Array.isArray(body.travelersPerRoom) || body.travelersPerRoom.length === 0)
    ) {
      const travelerIds: string[] = Array.isArray(body.traveler) ? body.traveler : (body.traveler ? [body.traveler] : []);

      const travelersObj = travelerIds
        .map(id => this.companyUsers.find(u => u.uuid === id))
        .filter(Boolean)
        .map(u => ({ uuid: u.uuid, name: u.name, lastname: u.lastname }));

      const room1 = travelersObj.length ? travelersObj : travelerIds.map(uuid => ({ uuid }));

      body.rooms = 1;
      body.travelersPerRoom = [room1];

      delete body.traveler;
    }

    this.sendInfo.emit(body);
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0 && this.userType === 'EMPLOYEE') {
      for (let i = 0; i < event.target.files.length; i++) {
        this.files.push(event.target.files[i]);
      }
    }
  }

  onFileChangeCustom(event: any, roomIndex: number) {
    if (event.target.files.length > 0 && this.userType === 'EMPLOYEE') {
      const roomsArray = this.form.get('roomsInfo') as FormArray;
      const room = roomsArray.at(roomIndex);
      const currentFiles = room.get('files').value || [];
      room.get('files').setValue([...currentFiles, ...Array.from(event.target.files)]);
    }
  }

  removeFile(index: number) {
    const fileToRemove = this.existingFiles[index] || this.files[index];
    if (fileToRemove.url) {
      this.filesToRemove.push(fileToRemove.url);
      this.existingFiles.splice(index, 1);
    } else {
      this.files.splice(index, 1);
    }
  }

  removeFileCustom(roomIndex: number, fileIndex: number) {
    const roomsArray = this.form.get('roomsInfo') as FormArray;
    const room = roomsArray.at(roomIndex);
    const currentFiles = room.get('files').value || [];
    const updatedFiles = currentFiles.slice();
    updatedFiles.splice(fileIndex, 1);
    room.get('files').setValue(updatedFiles);
  }

  getOutMinDateManual() {
    return this.utilsService.getOutDate(
      this.minDateNgStruct,
      this.form.controls["checkIn"].value
    );
  }

  handleTravel(dataTravel: any) {
    this.bodyTravel = dataTravel;
    this.travelUtilsService.setTravelLocalStorage(this.bodyTravel);
    this.translate.get(["project.form.saved"]).subscribe((resp) => {
      this.ngxToastrService.typeSuccess(resp["project.form.saved"], "");
    });
  }

  closeModalCross() {
    this.modalService.dismissAll();
  }

  getCompanyUsersAndUpdate() {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));

        this.filteredUsers = [...this.companyUsers];

        const initialTravelers = this.buildInitialEditableTravelers();

        this.externalTravelers = initialTravelers.filter(
          (traveler) => traveler.type === 'external'
        );

        this.selectedTravelers = [...initialTravelers];

        this.form.get('traveler')?.setValue(
          this.selectedTravelers
            .map((traveler) => traveler.uuid)
            .filter(Boolean),
          { emitEvent: false }
        );

        this.syncSelectedTravelersWithControl();
      },
      (err) => console.error('Error fetching users:', err)
    );
  }

  getCompanyUsers(callback?: Function) {
    this.companyService.getCompanyUsers(this.companyUuid).subscribe(
      (res) => {
        this.companyUsers = res.map(user => ({
          name: user.name,
          lastname: user.lastname,
          uuid: user.uuid
        }));
        this.filteredUsers = [...this.companyUsers];  
        if (this.form?.get('traveler')) {
          this.syncSelectedTravelersWithControl();
        }
        if (callback) {
          callback();
        }
      },
      (err) => {}
    );
  }

  updateTravelersPerRoom(roomCount: number) {
    const travelersArray = this.getTravelersPerRoom;
    const currentValues = travelersArray.value;
  
    while (travelersArray.length < roomCount - 1) {
      travelersArray.push(this.formBuilder.control([]));
    }
    while (travelersArray.length > roomCount - 1) {
      travelersArray.removeAt(travelersArray.length - 1);
    }
    travelersArray.controls.forEach((control, index) => {
      if (currentValues[index]) {
        control.setValue(currentValues[index]);
      }
    });
  }
  
  compareUsers(user1: any, user2: any): boolean {
    if (!user1 || !user2) {
      return user1 === user2;
    }

    return user1.uuid === user2.uuid;
  }
  
  get getTravelersPerRoom(): FormArray {
    return this.form.get('travelersPerRoom') as FormArray;
  }

  get getDefaultTraveler(): FormArray {
    return this.form.get('defaultTraveler') as FormArray;
  }
  
  isFormValid(): boolean {
    if (this.data?.hotel || this.userType !== "EMPLOYEE" || this.bookType === 'airbnb') {
      return true;
    }

    const defaultTraveler = this.form.get('defaultTraveler')?.value;

    if (this.editing) {
      return this.form.valid && Array.isArray(defaultTraveler) && defaultTraveler.length > 0;
    }

    const travelersPerRoom = this.getTravelersPerRoom.value;
    const allRoomsHaveTravelers = travelersPerRoom.every(room => room && room.length > 0);

    return this.form.valid && Array.isArray(defaultTraveler) && defaultTraveler.length > 0 && allRoomsHaveTravelers;
  }

  async showPaymentCardSelector(): Promise<BookingPaymentSelection | null> {
    const companyCards = this.normalizePaymentCards(this.user?.paymentCards);
    const personalCards = this.normalizePaymentCards(
      this.user?.personalPaymentCards
    );

    if (this.company?.bookedWithoutCard) {
      if (personalCards.length === 0) {
        return {
          payNow: false,
        };
      }

      const result = await Swal.fire({
        title: this.translate.instant("payment.pay-now-title"),
        text: this.translate.instant("payment.pay-now-question"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.translate.instant("payment.pay-now"),
        cancelButtonText: this.translate.instant("payment.pay-later"),
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: "flexible-payment-swal",
        },
      });

      if (!result.isConfirmed) {
        return {
          payNow: false,
        };
      }

      const selectedCard = await this.openPaymentCardModal(
        [],
        personalCards
      );

      if (!selectedCard) {
        return null;
      }

      return {
        payNow: true,
        card: {
          name: selectedCard.name,
          token: selectedCard.token,
        },
      };
    }

    if (companyCards.length === 0 && personalCards.length === 0) {
      this.ngxToastrService.typeInfo(
        null,
        this.translate.instant("common.no-card-user-error")
      );

      return null;
    }

    const defaultToken =
      this.company?.cardRedsys?.find(
        (card) => card?.isDefault && card?.token
      )?.token || null;

    const orderedCompanyCards = defaultToken
      ? [
          ...companyCards.filter((card) => card.token === defaultToken),
          ...companyCards.filter((card) => card.token !== defaultToken),
        ]
      : companyCards;

    const selectedCard = await this.openPaymentCardModal(
      orderedCompanyCards,
      personalCards
    );

    if (!selectedCard) {
      return null;
    }

    return {
      payNow: true,
      card: {
        name: selectedCard.name,
        token: selectedCard.token,
      },
    };
  }

  trackByUuid(_: number, user: { uuid: string }) { return user.uuid; }

  applyFilter(filterValue: string) {
    const v = (filterValue || '').trim().toLowerCase();
    this.filteredUsers = !v
      ? [...this.companyUsers]
      : this.companyUsers.filter(u =>
          `${u.name} ${u.lastname}`.toLowerCase().includes(v)
        );
  }

  initRoomsInfo(count: number) {
    const roomsInfoArray = this.form.get('roomsInfo') as FormArray;
    roomsInfoArray.clear();
    for (let i = 0; i < count; i++) {
      roomsInfoArray.push(this.formBuilder.group({
        price: ['', [Validators.required, Validators.pattern(/^\d+([.,]\d{1,2})?$/)]],
        wholesalePrice: ['', [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]],
        files: [[]],
        roomType: [''],
        boardType: [''],
        freeTaxes: [false],
        provider: [''],
        marketingFee: ['', [Validators.pattern(/^\d+([.,]\d{1,2})?$/)]]
      }));
    }
  }

private loadHotelProviders(): void {
  this.loadingHotelProviders = true;

  this.providersService.getProviders('hotel' as ProviderType).subscribe({
    next: (items) => {
      const providers = (items || []).filter(p => !!p?.uuid && !!p?.name);

      const currentRaw =
        (this.data?.provider ||
         this.form?.get('provider')?.value ||
         ''
        ).toString().trim();

      let selectedUuid: string | null = null;

      if (currentRaw) {
        const byUuid = providers.find(p => p.uuid === currentRaw);
        if (byUuid) {
          selectedUuid = byUuid.uuid;
        } else {
          const byName = providers.find(
            p => (p.name || '').toLowerCase() === currentRaw.toLowerCase()
          );
          if (byName) {
            selectedUuid = byName.uuid;
          }
        }
      }

      this.hotelProviderOptions = providers;
      if (selectedUuid && this.form?.get('provider')) {
        this.form.get('provider')!.setValue(selectedUuid);
      }
      this.loadingHotelProviders = false;
    },
    error: () => {
      this.hotelProviderOptions = [];
      this.loadingHotelProviders = false;
    }
  });
}

  private syncSelectedTravelersWithControl() {
    if (this.travelerSyncInitialized) return;
    this.travelerSyncInitialized = true;

    const ctrl = this.form.get('traveler') as FormControl;
    if (!ctrl) return;

    ctrl.valueChanges.subscribe((values: any) => {
      const ids: string[] = Array.isArray(values)
        ? values.filter(Boolean)
        : (values ? [values] : []);

      const previousSelected = [...this.selectedTravelers];

      const nextSelected: EditableTraveler[] = ids
        .map((id): EditableTraveler | null => {
          const previous = previousSelected.find(
            (traveler) => traveler.uuid === id
          );

          if (previous) {
            return previous;
          }

          const externalTraveler = this.externalTravelers.find(
            (traveler) => traveler.uuid === id
          );

          if (externalTraveler) {
            return externalTraveler;
          }

          const companyUser = this.companyUsers.find(
            (user) => user.uuid === id
          );

          if (companyUser) {
            return {
              type: 'internal' as const,
              uuid: companyUser.uuid,
              name: companyUser.name,
              lastname: companyUser.lastname,
            };
          }

          return null;
        })
        .filter((traveler): traveler is EditableTraveler => traveler !== null);

      this.selectedTravelers = nextSelected;

      this.syncDefaultTravelerFromSelected();
    });

    this.syncDefaultTravelerFromSelected();
  }

  onTravelerOptionToggle(uuid: string, ev: MatOptionSelectionChange) {
    if (!ev.isUserInput) return;

    const ctrl = this.form.get('traveler') as FormControl;

    const current: string[] = Array.isArray(ctrl.value)
      ? ctrl.value
      : (ctrl.value ? [ctrl.value] : []);

    if (!ev.source.selected) {
      const next = current.filter(id => id !== uuid);
      ctrl.setValue(next, { emitEvent: true });
      return;
    }

    const without = current.filter(id => id !== uuid);
    let next = [...without, uuid];

    if (next.length > this.maxSelection) {
      next = next.slice(next.length - this.maxSelection);
    }

    ctrl.setValue(next, { emitEvent: true });
  }

  onTravelerOpenedChange(opened: boolean) {
    if (!opened) {
      this.filteredUsers = [...this.companyUsers];
    }
  }

  private syncDefaultTravelerFromSelected() {
    const ctrl = this.form.get('defaultTraveler');

    if (!ctrl) {
      return;
    }

    const isCustomHotelEdit =
      this.editing &&
      !this.data?.hotel &&
      this.bookType !== 'airbnb';

    const updated = this.selectedTravelers
      .filter((traveler) => {
        if (isCustomHotelEdit) {
          return true;
        }

        return traveler.type === 'internal';
      })
      .map((traveler) => ({
        type: traveler.type,
        uuid: traveler.uuid,
        name: traveler.name,
        lastname: traveler.lastname
      }));

    ctrl.setValue(updated, { emitEvent: false });
  }

  onSelectToggle(opened: boolean) {
  if (!opened) {
      this.filteredUsers = [... this.companyUsers];
    }
  }

  applyBackendValidationErrors(validationErrors: any[]): void {
    this.backendValidationErrors = {};

    validationErrors.forEach((err) => {
      const backendPath = err.field;

      this.backendValidationErrors[backendPath] = err.type || 'invalid';

      const controlPath = this.mapBackendPathToAngularPath(backendPath);
      const control = this.form.get(controlPath);

      if (control) {
        control.setErrors({
          ...(control.errors || {}),
          backend: err.type || 'invalid',
        });
        control.markAsTouched();
        control.markAsDirty();
      }
    });

    this.isInvalid = true;
  }

  hasBackendError(path: string): boolean {
    return !!this.backendValidationErrors[path];
  }

  getBackendError(path: string): string {
    return this.backendValidationErrors[path] || '';
  }

  private mapBackendPathToAngularPath(path: string): string {
    const directMap: Record<string, string> = {
      destinationName: 'city',
      hotelName: 'hotel',
      checkIn: 'checkIn',
      checkOut: 'checkOut',
      userUuid: 'userUuid',
      comments: 'comments',
      price: 'price',
      wholesalePrice: 'wholesalePrice',
      marketingFee: 'marketingFee',
      customCode: 'customCode',
      costCenter: 'costCenter',
      supplierInvoice: 'supplierInvoice',
      bookType: 'bookType',
      providerUuid: 'provider',
      invoiced: 'invoiced',
      locator: 'locator',
      rooms: 'rooms',
      freeTaxes: 'freeTaxes',
    };

    if (directMap[path]) {
      return directMap[path];
    }

    const roomsInfoProviderMatch = path.match(/^roomsInfo\.(\d+)\.providerUuid$/);
    if (roomsInfoProviderMatch) {
      return `roomsInfo.${roomsInfoProviderMatch[1]}.provider`;
    }

    if (/^roomsInfo\.\d+\./.test(path)) {
      return path;
    }

    const travelersPerRoomMatch = path.match(/^travelersPerRoom\.(\d+)\.travelers/);
    if (travelersPerRoomMatch) {
      const roomIndex = Number(travelersPerRoomMatch[1]);

      if (roomIndex === 0) {
        return 'defaultTraveler';
      }

      return `travelersPerRoom.${roomIndex - 1}`;
    }

    return path;
  }

  private buildInitialEditableTravelers(): EditableTraveler[] {
    const userUuids = Array.isArray(this.data?.userUuid)
      ? this.data.userUuid
      : (this.data?.userUuid ? [this.data.userUuid] : []);

    const guests = Array.isArray(this.data?.guests)
      ? this.data.guests
      : [];

    const normalize = (value: string = '') =>
      value
        .toString()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .trim()
        .toLowerCase();

    const internalUsers = userUuids
      .map((uuid) => this.companyUsers.find((user) => user.uuid === uuid))
      .filter(Boolean);

    if (guests.length > 0) {
      return guests.map((guest: any, index: number): EditableTraveler => {
        const guestName = normalize(guest?.name);
        const guestSurname = normalize(guest?.surname || guest?.lastname);

        const matchedInternalUser = internalUsers.find((user) => {
          const userName = normalize(user.name);
          const userLastname = normalize(user.lastname);

          return guestName === userName && guestSurname === userLastname;
        });

        if (matchedInternalUser) {
          return {
            type: 'internal',
            uuid: matchedInternalUser.uuid,
            name: guest?.name || matchedInternalUser.name || '',
            lastname: guest?.surname || guest?.lastname || matchedInternalUser.lastname || '',
          };
        }

        return {
          type: 'external',
          uuid: this.createExternalTravelerUuid(guest, index),
          name: guest?.name || '',
          lastname: guest?.surname || guest?.lastname || '',
        };
      });
    }

    return internalUsers.map((user): EditableTraveler => ({
      type: 'internal',
      uuid: user.uuid,
      name: user.name || '',
      lastname: user.lastname || '',
    }));
  }

  get selectedExternalTravelers(): EditableTraveler[] {
    return this.externalTravelers;
  }

  get selectedInternalTravelerUuids(): string[] {
    return this.selectedTravelers
      .filter((traveler) => traveler.type === 'internal' && !!traveler.uuid)
      .map((traveler) => traveler.uuid);
  }

  get selectedTravelersNames(): string {
    return this.selectedTravelers
      .map((traveler) => `${traveler.name} ${traveler.lastname}`.trim())
      .join(', ');
  }

  changeExternalTravelerName(index: number, field: 'name' | 'lastname', value: string): void {
    const traveler = this.externalTravelers[index];

    if (!traveler) {
      return;
    }

    traveler[field] = value;

    const selectedTraveler = this.selectedTravelers.find(
      (selected) => selected.uuid === traveler.uuid
    );

    if (selectedTraveler) {
      selectedTraveler[field] = value;
    }

    const isCustomHotelEdit =
      this.editing &&
      !this.data?.hotel &&
      this.bookType !== 'airbnb';

    if (isCustomHotelEdit) {
      this.syncDefaultTravelerFromSelected();
    }
  }

  private createExternalTravelerUuid(guest: any, index: number): string {
    const raw = `${guest?.name || ''}-${guest?.surname || guest?.lastname || ''}-${index}`
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .toLowerCase();

    return `external-${raw}`;
  }

  toggleExternalGuestFormForRoom(roomIndex: number): void {
    this.externalGuestModeByRoom[roomIndex] = !this.externalGuestModeByRoom[roomIndex];
  }

  cancelExternalGuestForRoom(roomIndex: number): void {
    this.externalGuestNameByRoom[roomIndex] = '';
    this.externalGuestLastnameByRoom[roomIndex] = '';
    this.externalGuestModeByRoom[roomIndex] = false;
  }

  addExternalGuestForRoom(roomIndex: number): void {
    const name = (this.externalGuestNameByRoom[roomIndex] || '').trim();
    const lastname = (this.externalGuestLastnameByRoom[roomIndex] || '').trim();

    if (!name || !lastname) {
      const messageKey = !name && !lastname
        ? 'hotel.external-guest.name-lastname-required'
        : !name
          ? 'hotel.external-guest.name-required'
          : 'hotel.external-guest.lastname-required';

      this.translate
        .get(['common.attention', messageKey])
        .pipe(take(1))
        .subscribe((result) => {
          this.ngxToastrService.typeInfo(
            result['common.attention'],
            result[messageKey]
          );
        });

      return;
    }

    const traveler: RoomTraveler = {
      type: 'external',
      uuid: this.createExternalTravelerUuid({ name, surname: lastname }, Date.now()),
      name,
      lastname,
    };

    const control = roomIndex === 0
      ? this.form.get('defaultTraveler')
      : this.getTravelersPerRoom.at(roomIndex - 1);

    const currentValue = Array.isArray(control?.value)
      ? control.value
      : [];

    control?.setValue([...currentValue, traveler]);
    control?.markAsDirty();
    control?.markAsTouched();
    control?.updateValueAndValidity();

    this.externalGuestNameByRoom[roomIndex] = '';
    this.externalGuestLastnameByRoom[roomIndex] = '';
    this.externalGuestModeByRoom[roomIndex] = false;
  }

  getRoomTravelerControl(roomIndex: number): FormControl {
    return roomIndex === 0
      ? this.form.get('defaultTraveler') as FormControl
      : this.getTravelersPerRoom.at(roomIndex - 1) as FormControl;
  }

  getRoomExternalTravelers(roomIndex: number): any[] {
    const control = this.getRoomTravelerControl(roomIndex);

    if (!control || !Array.isArray(control.value)) {
      return [];
    }

    return control.value.filter((traveler) => traveler?.type === 'external');
  }

  getTravelerDisplayName(traveler: any): string {
    return `${traveler?.name || ''} ${traveler?.lastname || traveler?.surname || ''}`.trim();
  }

  getRoomTravelerNames(roomIndex: number): string {
    const control = this.getRoomTravelerControl(roomIndex);

    if (!control || !Array.isArray(control.value)) {
      return '';
    }

    return control.value
      .map((traveler) => this.getTravelerDisplayName(traveler))
      .filter(Boolean)
      .join(', ');
  }

  private buildInitialCustomRoomTravelers(): RoomTraveler[] {
    const userUuids = Array.isArray(this.data?.userUuid)
      ? this.data.userUuid
      : (this.data?.userUuid ? [this.data.userUuid] : []);

    const guests = Array.isArray(this.data?.guests)
      ? this.data.guests
      : [];

    const normalize = (value: string = '') =>
      value
        .toString()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .trim()
        .toLowerCase();

    const internalUsers = userUuids
      .map((uuid) => this.companyUsers.find((user) => user.uuid === uuid))
      .filter(Boolean);

    if (guests.length > 0) {
      return guests.map((guest: any, index: number): RoomTraveler => {
        const guestName = normalize(guest?.name);
        const guestSurname = normalize(guest?.surname || guest?.lastname);

        const matchedInternalUser = internalUsers.find((user) => {
          const userName = normalize(user.name);
          const userLastname = normalize(user.lastname);

          return guestName === userName && guestSurname === userLastname;
        });

        if (matchedInternalUser) {
          return {
            type: 'internal',
            uuid: matchedInternalUser.uuid,
            name: guest?.name || matchedInternalUser.name || '',
            lastname: guest?.surname || guest?.lastname || matchedInternalUser.lastname || '',
          };
        }

        return {
          type: 'external',
          uuid: this.createExternalTravelerUuid(guest, index),
          name: guest?.name || '',
          lastname: guest?.surname || guest?.lastname || '',
        };
      });
    }

    return internalUsers.map((user): RoomTraveler => ({
      type: 'internal',
      uuid: user.uuid,
      name: user.name || '',
      lastname: user.lastname || '',
    }));
  }

  changeRoomExternalTravelerName(
    roomIndex: number,
    travelerUuid: string,
    field: 'name' | 'lastname',
    value: string
  ): void {
    const control = this.getRoomTravelerControl(roomIndex);

    if (!control || !Array.isArray(control.value)) {
      return;
    }

    const currentTravelers = control.value;

    const travelerToUpdate = currentTravelers.find(
      (traveler: RoomTraveler) => traveler.uuid === travelerUuid
    );

    if (!travelerToUpdate) {
      return;
    }

    travelerToUpdate[field] = value;

    control.setValue(currentTravelers, { emitEvent: false });
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
  }

  private mapRequestTravelerToRoomTraveler(traveler: any): RoomTraveler {
    return {
      type: traveler?.type || 'internal',
      uuid: traveler?.uuid,
      name: traveler?.name || '',
      lastname: traveler?.lastname || traveler?.surname || '',
    };
  }

  private loadRequestTravelersPerRoom(): void {
    if (
      !this.request ||
      this.bookType === 'airbnb' ||
      !Array.isArray(this.request.travelersPerRoom)
    ) {
      return;
    }

    const roomsValue =
      Number(this.request?.rooms) ||
      this.request.travelersPerRoom.length ||
      1;

    this.form.patchValue({ rooms: roomsValue }, { emitEvent: false });

    this.updateTravelersPerRoom(roomsValue);

    const firstRoomTravelers =
      this.request.travelersPerRoom[0]?.travelers?.map((traveler) =>
        this.mapRequestTravelerToRoomTraveler(traveler)
      ) || [];

    this.form.get('defaultTraveler')?.setValue(firstRoomTravelers);

    const restRoomsTravelers = this.request.travelersPerRoom
      .slice(1)
      .map((room) =>
        (room.travelers || []).map((traveler) =>
          this.mapRequestTravelerToRoomTraveler(traveler)
        )
      );

    restRoomsTravelers.forEach((roomTravelers, index) => {
      this.getTravelersPerRoom.at(index)?.setValue(roomTravelers);
    });

    this.form.get('defaultTraveler')?.markAsPristine();
    this.form.get('defaultTraveler')?.updateValueAndValidity();

    this.getTravelersPerRoom.controls.forEach((control) => {
      control.markAsPristine();
      control.updateValueAndValidity();
    });
  }

  trackByTravelerUuid(index: number, traveler: RoomTraveler): string {
    return traveler?.uuid || `traveler-${index}`;
  }

  private normalizePaymentCards(cards: any): any[] {
    const normalizedCards = Array.isArray(cards)
      ? cards
      : cards
        ? [cards]
        : [];

    return normalizedCards.filter(
      (card) =>
        card?.token &&
        typeof card?.name === "string" &&
        card.name.trim() !== ""
    );
  }

  private openPaymentCardModal(
    companyCards: any[],
    personalCards: any[]
  ): Promise<any | null> {
    return new Promise((resolve) => {
      let resolved = false;

      const modalRef = this.modalService.open(UserCardModalComponent, {
        windowClass: "custom-modal-user-card",
        centered: true,
        backdrop: "static",
        keyboard: false,
      });

      modalRef.componentInstance.company = this.company;
      modalRef.componentInstance.bookCards = companyCards;
      modalRef.componentInstance.bookPersonalCards = personalCards;
      modalRef.componentInstance.fromBookSelect = true;

      modalRef.componentInstance.cardSelected
        .pipe(take(1))
        .subscribe((selectedCard) => {
          resolved = true;
          resolve(selectedCard);
        });

      modalRef.result
        .then(() => {
          if (!resolved) {
            resolve(null);
          }
        })
        .catch(() => {
          if (!resolved) {
            resolve(null);
          }
        });
    });
  }


}
